module.exports = __webpack_public_path__ + "static/media/pay-way.6c49b231.png";